import React, { forwardRef } from "react";
import { Button as SpectrumButton } from "@react-spectrum/s2";
import { s2UnslottedLabel } from "./s2UnslottedLabel";

type ButtonProps = React.ComponentProps<typeof SpectrumButton>;

export const Button = forwardRef<
  React.ElementRef<typeof SpectrumButton>,
  ButtonProps
>((props, ref) => {
  const { children, ...rest } = props;
  const inner =
    typeof children === "string" || typeof children === "number"
      ? children
      : s2UnslottedLabel(children);
  return (
    <SpectrumButton ref={ref} {...rest}>
      {inner}
    </SpectrumButton>
  );
});

Button.displayName = "Button";
